import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  rightAlign: {
    width: '100%',
    textAlign: 'right'
  },
  cellContent: {
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  wrapper: {
    height: '100%',
    '& .MuiDataGrid-columnHeaderTitleContainerContent': {
      width: '100%'
    },
    '& .MuiDataGrid-cell': {
      padding: '20px 15px'
    },
    '& .MuiDataGrid-root': {
      boxShadow: 'none'
    },
    '& .MuiDataGrid-columnHeader:nth-of-type(1)': {
      paddingLeft: '0'
    },
    '& .MuiDataGrid-cell:first-of-type': {
      paddingLeft: '10px',
      '& > span': {
        overflow: 'hidden'
      }
    }
  },
  statusText: {
    fontSize: '15px',
    lineHeight: '19px'
  },
  propertyCell: {
    display: 'flex',
    alignItems: 'center'
  },
  propertyCellIcon: {
    width: '21px',
    height: '21px',
    display: 'block',
    marginRight: '4px',
    borderRadius: '2px',
    position: 'relative',
    backgroundColor: '#F8F9FA',
    '& .MuiSvgIcon-root': {
      fontSize: '21px',
      '& path': {
        fill: '#B8C4CE'
      }
    }
  },
  propertyCellStatus: {
    right: '0',
    bottom: '0',
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    position: 'absolute',
    border: '1px solid #fff',
    backgroundColor: '#EBF0F5',
    '&.success': {
      backgroundColor: '#27BB66'
    },
    '&.error': {
      backgroundColor: '#c43131'
    },
    '&.warning': {
      backgroundColor: '#d5a320'
    }
  }
});
export default useStyles;